<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Vehicles Start & End Trip Details</strong>
               
          </div>       
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">            
            <b-row> 
              <b-col sm="4">
                  <b-col sm="12">
            <b-form-group label="Select Vehicle"  :label-cols="4" >
                    <b-form-select v-model="vehicle_id" name="vehicle_id"  >
                        <option value="">--Select--</option>
                        <option :value="vehicle.vehicle_id" v-for="vehicle in vehicleitems"  :key="vehicle.vehicle_id" >
                          <!-- {{vehicle.vehicle_id}} - -->
                       {{vehicle.vehicle_name}} -  {{vehicle.vehicle_no}}
                        </option>
                        </b-form-select>      
                </b-form-group>   
                 </b-col>
              </b-col> 
                <b-col sm="4">
                  <!-- <b-col sm="12"> -->
                <b-form-group label="Start Date :"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              <!-- </b-col> -->
              </b-col>
               <b-col sm="4">
                <b-form-group label="End Date :"  :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
              <!-- <b-col md="4" class="my-1">

                <b-form-group >
                  
                    <b-form-input v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group>
       
              </b-col> -->
             
                             
            </b-row>
            
            <b-row>
              <b-col sm="4" >
                <b-col sm="12">
                  <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group >
                  
                    <b-form-input v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group> -->
                </b-col>
              </b-col>
               <b-col sm="8" class="my-1 text-right">
                
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="startendtripDetails()"> Search</b-button>
               
                  <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button>
                 
                  <b-button v-if="totalRows>0" type="submit" variant="primary" size="md" style="margin-left:20px;" @click="downloadCSV">Download </b-button>
                 
                </b-form-group>
              
              </b-col>
               
  
            </b-row>
            <b-row>
            

              
<!--              <div id="overlay" >
             <div class="loader"></div>
           </div>
 -->           
             
              <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
              </b-col>
            </b-row> 
          </b-form>         
        
            <b-col sm="12" style="overflow:auto;">  
            

            <b-table  responsive show-empty stacked="md" :busy="isBusy"   :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
               <template slot="action" slot-scope="row">
                  <b-button size="sm" @click="vehicleMeterimage(row.item)"  data-toggle="tooltip" title="View Meter Reading"  class="mr-1">
                    View
                  </b-button>
               </template>              
          </b-table>
        </b-col>
          <b-col md="12" class="my-1" v-if="totalRows>10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>
          <b-modal  title="Vehicle Meter Reading" size="xl" v-model="vehicleMeter" @ok="vehicleMeter = false" hide-footer>
       
        <template slot="default" slot-scope="{ hide }">
         
          <b-row>
             <b-col sm="12" style="overflow:auto;">  
            

            <b-table  responsive show-empty stacked="md" :busy="isBusyReading"   :items="vehiclereadingitems" :fields="vehiclereadingfields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              <template slot="startmeterimage" slot-scope="row">
                <div v-if="row.item.startmeterimage != null">
                <img  v-bind:src="row.item.startmeterimage"   class="img_class" @click="getMeterimage(row.item.startmeterimage)" style="cursor:pointer">
                </div>
                <br>
                <div data-toggle="tooltip" title="Start LatLong">{{row.item.startlatlong}}</div>
              </template> 
                <template slot="endmeterimage" slot-scope="row">
                  <div v-if="row.item.endmeterimage != null">
                    <img  v-bind:src="row.item.endmeterimage"   class="img_class" @click="getMeterimage(row.item.endmeterimage)" style="cursor:pointer">
                  </div>
                  <br>
                  <div v-if="row.item.endlatlong != null" data-toggle="tooltip" title="End LatLong">
                   {{row.item.endlatlong}}
                  </div>
                   
              </template>       
          </b-table>
        </b-col>
          <!-- <b-col md="12" class="my-1" v-if="totalRows>10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> -->
          </b-row>
 

              <footer class="text-right">
               <!--  <b-button size="sm" variant="primary" type="submit" class="mr-4">Update</b-button> -->
                 <b-button size="sm" variant="danger" @click="vehicleReadingclose()" >
                     Cancel
                </b-button>
              </footer>
           
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          
          <b-button size="sm" variant="danger" @click="vehicle()" style="display:none">
            Cancel
          </b-button>
         
        </template>
      </b-modal>
          <b-modal  size="lg" title="Zoom Image" v-model="openimagemodel" @ok="openimagemodel = false" hide-footer>
          <!-- <template slot="modal-header">
          <h5>Zoom Image</h5>
          
          <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template> -->
          <template slot="default" slot-scope="{ hide }">
            <div id="btn_navbar" style="text-align:center">
              <button type="button" class="btn btn-primary" @click="zoomin()"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom In</i></button>&nbsp;
              <button type="button" class="btn btn-danger" @click="zoomout()"><i class="fa fa-search-minus" aria-hidden="true">&nbsp;Zoom Out</i></button>
              </div>

              <div class="main1" style="display:flex;justify-content:center">
              <img  v-bind:src="zoomImage" id="meter" height="200" width="250" style="padding:5px;"/>
              </div>


            

              <div slot="footer" class="text-right">
                 
                <b-button  size="sm" variant="danger"   
                 @click="openimagecancel()">cancel</b-button>

              </div>

          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
        </b-card>
      </b-col>
    </b-row>    
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
      items:[],    
      isBusy: false,   
      data1:[],
      // perPage:  10,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
   
     
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      vehicle_id:'',
      
      fields: [
    

          // { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
          { key: 'vehicleId', label: 'ID', sortable: true, sortDirection: 'desc' },
          { key: 'vehicleno', label: 'Vehicle No.', sortable: true},
           
          { key: 'vehicleName', label: 'Vehicle Name', sortable: true},
          { key: 'startdate', label: 'Start Date', sortable: true, sortDirection: 'desc' },
          { key: 'startkmReading', label: 'Start KM Reading', sortable: true},
          { key: 'endkmreading', label: 'End KM Reading', sortable: true},
          { key: 'TotalKmforatrip', label: 'Total Trip KM', sortable: true, sortDirection: 'desc' },
           { key: 'enddate', label: 'End Date', sortable: true},
           { key: 'action', label: 'Action', sortable: true},
         
          
          // { key: 'destinationaddress', label: 'Destination Address', sortable: true},

          
          
          // { key: 'createddate', label: 'Created Date', sortable: true},
           // { key: 'startlatlong', label: 'LatLong', sortable: true},

                     
          

        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        searching:'',
        vehicleitems:[],
        vehicleMeter:false,
        isBusyReading:false,
        vehiclereadingitems:[],
        vehiclereadingfields:[ 
          { key: 'vehicle_id', label: 'ID', sortable: true, sortDirection: 'desc' },
          { key: 'startmeterreading', label: 'Start Reading', sortable: true},
           
          { key: 'startmeterimage', label: 'Start Meter Image', sortable: true},
          // { key: 'startlatlong', label: 'Start LatLong', sortable: true, sortDirection: 'desc' },
          // { key: 'startkmReading', label: 'Start KM Reading', sortable: true},
          { key: 'endmeterreading', label: 'End Reading', sortable: true},
          { key: 'endmeterimage', label: 'End Meter Image', sortable: true, sortDirection: 'desc' },
           // { key: 'endlatlong', label: 'End LatLong', sortable: true},
          ],
          zoomImage:'',
          openimagemodel:false,


    };
  },
  created: function() {
   
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.email=userInfo.sysemailid;
    this.displayvehicledetails();
    this.startendtripDetails();
  },
  methods: {
   
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {},
    
    



  
     startendtripDetails: function() {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
       this.isBusy = true;
      
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        var vehicleid=(this.vehicle_id!=null)?this.vehicle_id:"";
        
          var csvObj = {
            startdate: `${fromdate}`,
            enddate:`${formatdateto}`,
            vehicle_id:`${vehicleid}`
           };
         

        if(formatdateto< fromdate){  
           this.$fire({
                  text:"To date need to be greater than From date",
                  type: "warning",
                  timer: 30000
                }); 
                this.isBusy = false; 
                return false;       
        }
        console.log("csvObj",csvObj);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getTripInfoByVehicleId`, csvObj)
          .then(result => {
            console.log("Result",result);
             this.isBusy = false;

            if (result.body.returnmsg  === 'Successful') {
                this.items  = result.body.returnvalue;  
                this.totalRows=result.body.returnvalue.length;  
            }else{
             this.showdata = []
              this.items  = [];
              this.totalRows = 0;               
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },

 downloadCSV:function(){
        document.getElementById("overlay").style.display = "block";
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
       // this.isBusy = true;
      
        // var email=this.email;
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        var vehicleid=(this.vehicle_id!=null)?this.vehicle_id:"";
          var csvObj = {
            sysusermasterid:`${userInfo.sysusermasterid}`,
            // usertype:`${userInfo.user_type}`,
            startdate: `${fromdate}`,
            enddate:`${formatdateto}`,
            vehicle_id:`${vehicleid}`
          
           };
            console.log("JJJJJ",csvObj);
           // return false;
        if(formatdateto< fromdate){  
           this.$fire({
                  text:"To date need to be grater than From date",
                  type: "warning",
                  timer: 30000
                }); 
            document.getElementById("overlay").style.display = "none";
                // this.isBusy = false; 
                return false;       
        }
        // console.log("csvObj",csvObj);
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTripInfoByVehicleIdCsv`, csvObj)
          .then(result => {
            
          document.getElementById("overlay").style.display = "none";
           if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
         this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
        // alert("Can not Download");
       }

          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },

    
displayvehicledetails: function() {
       // this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {
        sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
          isactive:'1',
      };
      console.log('deliveryagentobj',deliveryagentobj);
      this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getVehicleListing`,
          deliveryagentobj
        )
        .then(result => {
          console.log("YYY",result);
          if (result.body.length > 0) {
            // this.isBusy = !this.isBusy
            // this.data = result.body;
           
            this.vehicleitems  = result.body;
             
            // this.totalRows = result.body.length
          } else {
            // this.isBusy = !this.isBusy
            // this.data = result.body;
            this.vehicleitems  = [];
            // this.totalRows = result.body.length
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    },


    
    
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
      clear: function() {
   this.searching="";
   this.selectDateFrom=new Date();
   this.selectDateTo=new Date();
    this.filter="";
    this.vehicle_id="";
    this.displayvehicledetails();
    this.startendtripDetails();

   
   
      
    },

    vehicleMeterimage:function(value){
       console.log("Test",value);
       this.vehicleInfo=value;
       this.displayvehicleReading(this.vehicleInfo);
       this.vehicleMeter=true;
    },
    displayvehicleReading: function(value) {
      let vehicleid=value.vehicleId.toString();
      let tripdate=value.startdate;
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
       this.isBusyReading = true;
      
        // var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        // var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        // var vehicleid=(this.vehicle_id!=null)?this.vehicle_id:"";
        
          var csvObj = {
            
            vehicleId:vehicleid,
            tripdate:tripdate
           };
         

       
        console.log("csvObj",csvObj);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleTripLatLong`, csvObj)
          .then(result => {
            console.log("Result",result);
             this.isBusyReading = false;

            if (result.body.returnmsg  === 'Successful') {
                this.vehiclereadingitems  = result.body.returnvalue;  
                // this.totalRows=result.body.returnvalue.length;  
            }else{
             
              this.vehiclereadingitems  = [];
              // this.totalRows = 0;               
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },
   
    vehicleReadingclose:function(){
      this.vehicleMeter=false;
    },

    getMeterimage:function(value){
      this.openimagemodel=true;
      this.zoomImage=value;
    },
    openimagecancel:function(){
      this.openimagemodel=false;
    },
    zoomin: function(){
        var myImg = document.getElementById("meter");
        var currWidth = myImg.clientWidth;
       
        if(currWidth >= 635) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        } 
    },
    zoomout: function(){
        var myImg = document.getElementById("meter");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },






  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
  padding: .2rem!important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
  .nameOfTheClass {
   max-width: 450px !important;
}
.orderidClass{
   max-width: 110px !important;
}
.awbClass{
  max-width: 110px !important;
}
.statusClass{
 max-width: 110px !important; 
}
.desitnationClass{
  max-width: 110px !important; 
}
.countryClass{
 max-width: 60px !important;  
}
.pickupClass{
  max-width: 100px !important; 
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.img_class {
    width: 100%;
    height: 150px ;
    margin-top: 5px;
    text-align: center;
  
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
</style>
